const jsonRegex = /^("(((?=\\)\\(["\\\/bfnrt]|u[0-9a-fA-F]{4}))|[^"\\\0-\x1F\x7F]+)*")$/;
export const Ajax = {
    get: (url, onSuccess, onError) => {
        let request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                let responseText = request.responseText;
                if (jsonRegex.test(responseText)) {
                    let json = JSON.parse(responseText);
                    onSuccess(json);
                } else {
                    onSuccess(responseText);
                }
            } else {
                onError({ code: request.status, message: request.responseText });
            }
        }
        request.onerror = onError;
        request.send();
    },
    post: (url, data, onSuccess, onError) => {
        let request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.onload = () => {
            if (request.status >= 200 && request.status < 400) {
                let responseText = request.responseText;
                let isJson = jsonRegex.test(responseText);
                if (isJson) {
                    let json = JSON.parse(responseText);
                    onSuccess(json);
                } else {
                    onSuccess(responseText);
                }
            } else {
                onError({ code: request.status, message: request.responseText });
            }
        }
        request.onerror = onError;
        request.send(data);
    }
}


// WEBPACK FOOTER //
// ./uPortal/Content/js/Extensions/ajax.js